import currencyFormats, { CURRENCY_CODE } from 'constants/currency-constants';

export default function formatCurrency({
  code,
  amount,
  symbol = '',
  formatOption = {},
  hideSymbol = false,
}) {
  if (typeof amount !== 'number') {
    return '';
  }
  const predefinedFormat = currencyFormats.find(f => f.code === code) || {};
  const { thousandFormat = '', decimalFormat = '', decimalDigits = 0 } = {
    ...predefinedFormat,
    ...formatOption,
  };

  const parts = amount.toFixed(decimalDigits).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandFormat);
  const formatedAmount =
    decimalFormat.length === 0 ? parts[0] : parts.join(decimalFormat);

  if (hideSymbol) return formatedAmount;

  const symbolForDisplay = symbol || predefinedFormat.symbol;

  return code === CURRENCY_CODE.Vietnam || code === CURRENCY_CODE.Cambodia
    ? `${formatedAmount}${symbolForDisplay}`
    : `${symbolForDisplay}${formatedAmount}`;
}
